import type { SocialBriefWidgetType } from '@inference.engine/widgets/web';
import { useTranslation } from 'react-i18next';

interface Props {
  data?: SocialBriefWidgetType;
}

/**
 * Store-free, prop-only preview of a social-brief widget: the brand name plus
 * the selected opportunity title and its description. Renders props.data only
 * — never touches the widget store or export deps.
 */
export const SocialBriefThumbnail = (props: Props) => {
  const { t } = useTranslation('contentTest');

  const item = props.data?.items[0];

  return (
    <div className="flex h-full flex-col gap-2 overflow-hidden">
      <p className="truncate text-sm font-semibold text-[#1A1A1A]">
        {item?.brandName || t('socialBriefWidget.socialBriefThumbnail.socialBrief')}
      </p>
      {item && (
        <div className="flex flex-col gap-0.5">
          <span className="line-clamp-1 text-xs font-medium text-[#1A1A1A]">
            {item.overview.opportunityTitle}
          </span>
          <span className="line-clamp-2 text-xs text-[#6C6962]">
            {item.overview.opportunityDescription}
          </span>
        </div>
      )}
    </div>
  );
};
